module.exports = __webpack_public_path__ + "images/emoji/shaved_ice.1fdcd8cb02dedec81d4d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/shaved_ice.png
// module id = itis
// module chunks = 13